// src/pages/LeaveReview/LeaveReview.tsx
import LeaveReviewComponent from 'components/LeaveReview';
import { FunctionComponent } from 'react';
import { RouteComponentProps } from 'react-router-dom';

interface MatchParams {
    uuid?: string;
}

type LeaveReviewPageProps = RouteComponentProps<MatchParams>;

const LeaveReviewPage: FunctionComponent<LeaveReviewPageProps> = props => {
    return <LeaveReviewComponent uuid={props.match.params.uuid || ''} />;
};

export default LeaveReviewPage;
